import React from 'react';
import { LoaderIndeterminateCircular } from '@stashinvest/react-components';

type Props = {
	// primarily exposed for setting height
	// default to min-h-screen
	className?: string;
};

export const Loader = ({ className = 'min-h-screen' }: Props) => {
	return (
		<div className={`flex items-center justify-center ${className}`}>
			<LoaderIndeterminateCircular />
		</div>
	);
};
